import clsx from "clsx";
import React from "react";
import { WizardStep } from "./Wizard";

interface WizardProgressBarProps {
  steps: WizardStep[];
  currentStep: number;
  onChangeStep?: (step: number) => void;
}

export const WizardProgressBar: React.FC<WizardProgressBarProps> = ({ steps, currentStep, onChangeStep }) => {
  return (
    <div className="px-10 py-4 medium:py-6 tall:py-8" data-wizard-progress-bar>
      <div className="relative mb-2">
        {/* Background and progress lines */}
        <div className="absolute left-[2%] right-[2%] top-2">
          {/* Background line */}
          <div className="absolute h-0.5 w-full bg-gray-300" />

          {/* Progress line */}
          <div
            className="bg-brand-700 absolute h-0.5 transition-all duration-300"
            style={{
              width: `${(currentStep / (steps.length - 1)) * 100}%`,
            }}
            data-wizard-progress-line
            data-wizard-progress-percent={(currentStep / (steps.length - 1)) * 100}
          />
        </div>

        {/* Dots and labels */}
        <div className="relative flex justify-between">
          {steps.map((s, i) => (
            <div
              className="flex cursor-pointer flex-col items-center"
              key={i}
              onClick={(e) => onChangeStep && onChangeStep(i)}
              data-wizard-step-indicator
              data-wizard-step-index={i}
              data-wizard-step-name={s.name}
              data-wizard-step-active={i === currentStep ? "true" : "false"}
            >
              <div
                className={clsx("h-4 w-4 rounded-full border-2 transition-colors", {
                  "border-brand-700 bg-brand-700": i <= currentStep,
                  "border-gray-300 bg-white": i > currentStep,
                })}
                data-wizard-step-dot
              />
              <div
                className={clsx("mt-1 text-sm", {
                  "text-gray-800": i === currentStep,
                  "text-gray-400": i !== currentStep,
                })}
                data-wizard-step-label
              >
                {s.name}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
